import { render } from "./icon-comment.vue?vue&type=template&id=78b037f0"
import script from "./icon-comment.vue?vue&type=script&lang=js"
export * from "./icon-comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__